<template>
    <div class="" v-if="data">
        <h2>Учебные достижения кадет</h2>
        <table class="table">
            <tr>
                <td>Количество обучающихся, успешно прошедших государственную итоговую аттестацию, – 9 класс<sup>4</sup></td>
                <td>{{data.pupils9}}</td>
            </tr>
            <tr>
                <td>Количество обучающихся, успешно прошедших государственную итоговую аттестацию, – 11 класс<sup>4</sup></td>
                <td>{{data.pupils11}}</td>
            </tr>
            <tr>
                <td>Количество обучающихся, принявших участие в независимой итоговой аттестации (предпрофессиональном экзамене)</td>
                <td>{{data.pupilsAttestation}}</td>
            </tr>
            <tr>
                <td>Количество обучающихся, успешно прошедших независимую итоговую аттестацию (предпрофессиональный экзамен)</td>
                <td>{{data.pupilsAttestationSuccess}}</td>
            </tr>
            <tr>
                <td>Количество обучающихся кадетского класса, принявших участие  в независимых диагностиках (история)<sup>4</sup></td>
                <td>{{data.pupilsDiagHistory}}</td>
            </tr>
            <tr>
                <td>Количество обучающихся кадетского класса, принявших участие  в независимых диагностиках (русский язык или математика)<sup>4</sup></td>
                <td>{{data.pupilsDiagRussian}}</td>
            </tr>
            <tr>
                <td>Количество обучающихся кадетского класса, успешно прошедших  независимую диагностику (история)<sup>4</sup></td>
                <td>{{data.pupilsDiagHistorySuccess}}</td>
            </tr>
            <tr>
                <td>Количество обучающихся кадетского класса, успешно прошедших  независимую диагностику (русский язык или математика)<sup>4</sup></td>
                <td>{{data.pupilsDiagRussianSuccess}}</td>
            </tr>
            <tr>
                <td>Количество обучающихся кадетского класса, принявших участие в демонстрационном  экзамене по военной подготовке (8 кл.)</td>
                <td>{{data.pupilsExamMilitary}}</td>
            </tr>
            <tr>
                <td>Количество обучающихся кадетского класса, успешно сдавших демонстрационный экзамен по военной подготовке</td>
                <td>{{data.pupilsExamMilitarySuccess}}</td>
            </tr>
            <tr>
                <td>Наличие обучающихся – победителей и призеров Регионального этапа Всероссийской олимпиады школьников</td>
                <td>{{data.pupilsRegionRussianOlympics}}</td>
            </tr>
            <tr>
                <td>Наличие обучающихся – победителей и призеров Финального этапа Московской олимпиады школьников<sup>5</sup> </td>
                <td>{{data.pupilsMoscowOlympics}}</td>
            </tr>
            <tr>
                <td>Наличие обучающихся – победителей и призеров заключительного этапа Всероссийской олимпиады школьников</td>
                <td>{{data.pupilsRussianOlympics}}</td>
            </tr>
            <tr>
                <td>Наличие обучающихся – победителей и призеров международных олимпиад школьников</td>
                <td>{{data.pupilsInternationalOlympics}}</td>
            </tr>
            <tr>
                <td>Наличие обучающихся – победителей и призеров Метапредметной олимпиады «Не прервется связь поколений»</td>
                <td>{{data.pupilsGenerationOlympics}}</td>
            </tr>
        </table>
        <div class="info-desc">
            <p>
                <sup>4</sup> независимые диагностики по профильным предметам (математика, история, русский язык), проводимые ГАОУ ДПО города Москвы «Московский центр качества образования» для обучающихся 8-х классов
            </p>
            <p>
                <sup>5</sup> Каждый обучающийся по каждому предмету учитывается один раз в соответствии с максимальным результатом. Один обучающийся учитывается не более чем по двум предметам
            </p>
        </div>
    </div>
</template>


<script>
    import Request from 'superagent';
    export default{

        data(){
            return {
                data:false
            };
        },


        created(){
            this.getData();
        },


        methods:{
            getData(){
                var path = this.$store.state.api+ this.$store.state.apiCadetAcademic +"?eoId="+this.$store.state.eoId;
                var $this = this;
                Request
                    .get(path)
                    .then((res)=>{
                    if(res.status == 200){
                        if(res.body.result == 'success' ){
                            $this.data = res.body.data;
                        }
                    }
                })
                ;
            }
        }
    }
</script>


<style>

</style>
